import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState } from "react";
import DeviceManagerAction from "./DeviceManagerAction";
import { handlePostRequest } from "../../services/PostTemplate";

function DeviceManagerData({ data }) {
  const [deviceManagerActionData, setdeviceManagerActionData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  const handleEditApiCall = async (mobile) => {
    const data = {
      Reserved1: "02",
      MobileNo: mobile,
    };
    try {
      await handlePostRequest(
        data,
        "zbizgateway/accountMaintainence/deviceVerificationInquiry"
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleAction = (rowData) => {
    setdeviceManagerActionData({
      DeviceName: rowData.deviceName,
      Id: rowData.id,
      MobileNo: rowData.mobileNo,
    });
    setShowModal(true);
    handleEditApiCall(rowData.mobileNo);
  };

  const actionTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <Button
          icon="pi pi-pencil"
          onClick={() => handleAction(rowData)}
          className={`p-button-rounded ${
            rowData?.approvalStatus === "Request Approved"
              ? "p-button-secondary"
              : "p-button-info"
          } p-mr-2`}
          disabled={
            rowData?.approvalStatus === "Request Approved" ? true : false
          }
        />
      </div>
    );
  };

  if (data === null) {
    return null;
  }

  return (
    <div>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <h3 className="mod_heading">Transactions</h3>
          </div>
        </div>
      </div>
      <div className="card">
        <DataTable
          value={data && data}
          selectionMode="multiple"
          metaKeySelection={false}
          scrollable
          scrollHeight="400px"
          style={{ minWidth: "50rem" }}
          tableStyle={{ minWidth: "120rem" }}
          dataKey="id"
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          emptyMessage="No data found."
        >
          <Column filter field="fullName" header="Full Name" />
          <Column filter field="mobileNo" header="Mobile No" />
          <Column filter field="deviceName" header="Device Name" />
          <Column filter field="approvalStatus" header="Approval Status" />
          <Column filter field="remarks" header="Remarks" />
          <Column filter field="requestedDate" header="Requested Date" />
          <Column filter field="requestedTime" header="Requested Time" />
          <Column body={actionTemplate} header="Action" />
        </DataTable>
      </div>
      <DeviceManagerAction
        data={deviceManagerActionData}
        onCloseModal={onCloseModal}
        showModal={showModal}
      />
    </div>
  );
}

export default DeviceManagerData;
